export function agentStateForLog(agent: connect.Agent) {
    const contactsSummary = agent.getContacts().map((c) => ({
        id: c.getContactId(),
        type: c.getType(),
        state: c.getState()?.type,
    }));
    const { state, timeStamp } = agent.getAvailabilityState();
    return {
        agentNextState: agent.getNextState()?.name || null,
        agentAvailabilityState: state,
        agentAvailabilityStateUpdatedAt: timeStamp.toISOString(),
        contactsCount: contactsSummary.length,
        contactsSummary,
    };
}
